import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { isEmptyString } from 'utils/stringHelpers';

export const useResetLocationState = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // only remove state when landing on segmentation page without search params
    if (location.state && isEmptyString(location.search)) {
      history.replace({
        ...location,
        state: undefined,
      });
    }
  }, [location, history]);
};
